/**
 * B26 — the onboarding save-failure copy, and the rule that picks between the
 * two messages.
 *
 * Lifted out of Step7Welcome for the same reason `lib/oauthChipCopy.ts` was
 * lifted out of AuthContext: the strings must be readable (and pinnable) with
 * no React, no router and no CSS in the graph — and a founder ratifying copy
 * should find every word in one plain file.
 *
 * ✅ RATIFIED (founder, 2026-08-27) — `SESSION_LOST_*` ratified as written.
 * Dash-free per the string brief.
 *
 * THE BUG THESE CLOSE (2026-08-26, first organic external user): the wizard
 * had no auth gate, so a friend of the founder answered every question with no
 * session. The final persist threw "Not signed in" and this screen offered
 * "Couldn't save your progress. Try again." — a retry whose every future click
 * would fail identically, because clicking it does not create a session. One
 * message was being used for two failures that differ in kind:
 *
 *   TRANSIENT (network / server) — a retry CAN succeed. With the route's auth
 *     gate in place a session is now guaranteed at this screen, so
 *     SAVE_RETRY_MESSAGE (unchanged, already shipped) is simply TRUE here.
 *
 *   SESSION LOST — a retry CANNOT succeed at any point in the future. The
 *     honest message says so, says where the answers are, and offers the one
 *     action that works. The promise it makes is real: the wizard blob is
 *     stamped with this athlete's own user id, so signing back in returns the
 *     same id and the Today gate migrates it (see loadPersistedStateForUser).
 */

/** Already-shipped string, unchanged. Transient failures only. */
export const SAVE_RETRY_MESSAGE = "Couldn't save your progress. Try again.";

/** RATIFIED (founder 2026-08-27) — needs founder ratification. */
export const SESSION_LOST_MESSAGE =
  'Your session ended before we could save. Your answers are safe on this device. Sign in again to finish.';

/**
 * Part 7 (onboarding_2_0_v1), the copy-register fix: the line above carries the
 * banned word "safe". Read only behind the flag; the line above stays as the
 * flag-off string (`onboardingAuthGate.b26.test.ts` pins it). The one changed
 * phrase is "kept on this device"; the claim, the order and the action are the
 * ratified string's own. Page strings list, screen 12.
 */
export const SESSION_LOST_MESSAGE_V2 =
  'Your session ended before we could save. Your answers are kept on this device. Sign in again to finish.';

/** RATIFIED (founder 2026-08-27) — needs founder ratification. */
export const SESSION_LOST_ACTION_LABEL = 'Sign in again';
